// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ProfileFeed-cls1___432070f0b9cef7a22c5{/*!*/}.ProfileFeed-cls2___62326742a89ab557018{height:auto;padding:4px 10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ProfileFeed-cls1___432070f0b9cef7a22c5",
	"cls2": "ProfileFeed-cls2___62326742a89ab557018 ProfileFeed-cls1___432070f0b9cef7a22c5"
};
export default ___CSS_LOADER_EXPORT___;
